import { cloneDeep, debounce, uniqueId } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { currentTab, datePresets, getCreatedAtByPreset, globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: Services.sendingsModeration,

  mixins: [ currentTab() ],

  data() {
    return {
      filter: {
        OwnerId: undefined,
        pattern: undefined,
        sender: undefined,
        range: {
          $gt: undefined,
          $lt: undefined
        }
      },

      preset: datePresets.today,
      presetRange: undefined,

      users: [],
      sendings: [],

      interval: undefined,

      usersLoading: false,
      sendingsLoading: false
    }
  },

  computed: {
    canGetSendingsModeration() {
      return this.checkPermissions(`advanced.${Services.sendingsModeration}.get`)
    },

    rangeForRequest() {
      return this.presetRange || this.filter.range
    },

    tabs() {
      const result = []
      if (this.checkPermissions(`advanced.${Services.sendings}.find`)) {
        result.push(Services.sendings)
      }
      if (this.checkPermissions(`advanced.${Services.tasks}.get`)) {
        result.push(Services.tasks)
      }

      return result
    }
  },

  watch: {
    filter: {
      handler() {
        this.getSendings()
      },
      deep: true
    },

    'filter.range'() {
      this.getUsers()
    },

    async preset() {
      this.setRangeByPreset()
      await this.getUsers()
      await this.getSendings()
    }
  },

  async mounted() {
    this.setRangeByPreset()
    await this.getUsers()
    this.interval = setInterval(() => {
      this.getUsers()
    }, 5 * 1000)

    this.currentTab = this.tabs[0]
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    getUsers: debounce(
      async function() {
        if (this.canGetSendingsModeration) {
          try {
            this.usersLoading = true
            const path = [ Services.sendingsModeration, Services.sendings ].join('/')
            const data = await request.find(path, undefined, { range: this.rangeForRequest })
            if (data) {
              this.users = data
            }
          } catch (error) {
            globalErrorHandler(error)
          } finally {
            this.usersLoading = false
          }
        }
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),

    getSendings: debounce(
      async function() {
        if (this.canGetSendingsModeration) {
          if (this.filter.OwnerId) {
            try {
              this.sendingsLoading = true
              const path = [ Services.sendingsModeration, Services.sendings ].join('/')
              const query = cloneDeep(this.filter)
              query.range = cloneDeep(this.rangeForRequest)
              const data = await request.find(path, undefined, query)
              if (data) {
                this.sendings = data.map((item, index) => {
                  item.uniqueKey = uniqueId(`${Services.sendingsModeration}-${index}-`)

                  return item
                })
              }
            } catch (error) {
              globalErrorHandler(error)
            } finally {
              this.sendingsLoading = false
            }
          }
        }
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),

    setRangeByPreset() {
      if (this.preset) {
        this.presetRange = getCreatedAtByPreset(this.preset)
      } else {
        this.presetRange = undefined
      }
    }
  },

  render
}
